import React from 'react';
import { Button } from '../ui/button';
import { X, Sparkles } from 'lucide-react';

const RightPanel = ({ children, isOpen, onClose, title }) => {
  if (!isOpen) return null;

  return (
    <div className="w-96 border-l bg-background flex flex-col h-full flex-shrink-0 transition-all duration-300 shadow-lg">
      {/* Branded header */}
      <div className="flex h-14 items-center justify-between px-4 flex-shrink-0 bg-gradient-to-r from-cyan-600 to-blue-600">
        <div className="flex items-center gap-2.5">
          <div className="flex items-center justify-center h-8 w-8 rounded-full bg-white/20 backdrop-blur-sm">
            <Sparkles className="h-4 w-4 text-white" />
          </div>
          <div>
            <h3 className="font-semibold text-white text-sm leading-tight">Niva</h3>
            <p className="text-[10px] text-cyan-100 leading-tight">AI Assistant</p>
          </div>
        </div>
        <Button variant="ghost" size="icon" onClick={onClose} className="h-8 w-8 text-white hover:bg-white/20">
          <X className="h-4 w-4" />
        </Button>
      </div>
      <div className="flex-1 overflow-hidden p-4">
        {children}
      </div>
    </div>
  );
};

export default RightPanel;
